export default "__VITE_ASSET__CNb4LOMi__"